var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5C4.74375 5.5 4.09635 5.23073 3.55781 4.69219C3.01927 4.15365 2.75 3.50625 2.75 2.75C2.75 1.99375 3.01927 1.34635 3.55781 0.807813C4.09635 0.269271 4.74375 0 5.5 0C6.25625 0 6.90365 0.269271 7.44219 0.807813C7.98073 1.34635 8.25 1.99375 8.25 2.75C8.25 3.50625 7.98073 4.15365 7.44219 4.69219C6.90365 5.23073 6.25625 5.5 5.5 5.5ZM0 11V9.075C0 8.68542 0.100375 8.32746 0.301125 8.00112C0.501875 7.67479 0.768167 7.42546 1.1 7.25313C1.81042 6.89792 2.53229 6.63162 3.26563 6.45425C3.99896 6.27687 4.74375 6.18796 5.5 6.1875C6.25625 6.18704 7.00104 6.27596 7.73438 6.45425C8.46771 6.63254 9.18958 6.89883 9.9 7.25313C10.2323 7.425 10.4988 7.67433 10.6996 8.00112C10.9003 8.32792 11.0005 8.68588 11 9.075V11H0Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.b28e8fbf4a659d3c586fa0c1619ad65d.svg";
export { ForwardRef as ReactComponent };